import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Typography,
} from '@material-ui/core';
import FormField from '../../../_components/Authorization/FormField';

const useStyles = makeStyles((theme) => ({
  block: {
    marginBottom: theme.spacing(3),
    paddingBottom: theme.spacing(2),
    borderBottom: '1px solid #eee',
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  blockTitle: {
    fontSize: '18px',
    fontWeight: 600,
    marginBottom: theme.spacing(2),
    color: theme.palette.black,
  },
  field: {
    marginBottom: theme.spacing(2),
  },
  errorText: {
    fontSize: '12px',
    color: theme.palette.error.main,
    marginTop: '4px',
  },
}));

/**
 * CommentBlock - Блок "Коментар до замовлення"
 */
const CommentBlock = ({
  formState,
  errors,
  handleChange,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={classes.block}>
      <Typography className={classes.blockTitle}>
        📝 {t('comment') || 'Коментар до замовлення'}
      </Typography>

      <FormField
        handleChange={handleChange}
        name="comment"
        title={t('enterComment') || 'Введіть коментар (опціонально)'}
        type="textarea"
        formState={formState}
        hasErrorText={errors?.comment ? errors.comment[0] : ''}
        required={false}
      />
    </Box>
  );
};

export default CommentBlock;
